// Maps the active i18n language to a BCP 47 locale that Intl / toLocaleString
// accept. Custom UI languages such as 'deConstruction' (German for the
// construction trade) are not valid language tags and would throw a RangeError.
export const toIntlLocale = (language) => {
  if (!language) return 'de-DE';
  if (language.startsWith('en')) return 'en-GB';
  return 'de-DE';
};
